const sendPostMessageUtils = (message: string) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(message)
  }

  window.parent.postMessage(message, '*')
}

export default sendPostMessageUtils
